import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateIglooPin } from './get-igloo-pin'

const issueIglooPin = async (clientId: string) => {
  const response = await authAPI.post(`/igloowork/${clientId}/pin`)
  return response.data
}

export const useIssueIglooPin = (clientId: string) => {
  const invalidate = useInvalidateIglooPin(clientId)
  return useMutation({
    mutationFn: () => issueIglooPin(clientId),
    onSuccess: invalidate,
  })
}
